/**
 * Curated Once UI barrel — ALL app imports of Once UI go through this file
 * (import { Flex } from "@/lib/once-ui"), never the package root.
 *
 * The package's real entry re-exports its modules/ tree, which statically
 * chains prism (CodeBlock) and recharts (charts) into every page — ~250KB
 * of transfer the site never renders. Importing each component through the
 * "./components/*" subpath keeps the bundle to exactly what the app uses.
 * Adding a NEW Once UI component to the app means adding its export line
 * below — the build fails loudly if it's missing.
 *
 * Caveat: many Once UI components import their own barrel internally
 * (`from "."`), which re-inflates the client graph of any page that ships
 * them. Keep barrel-dragging components (Media, InlineCode, SmartLink)
 * out of chrome that renders on every page.
 */

/* Types are erased at build time, so they may re-export from the real
   package entry without pulling anything into the bundle. */
export type {
  BorderStyle,
  ChartMode,
  ChartVariant,
  MediaProps,
  NeutralColor,
  ScalingSize,
  Schemes,
  SolidStyle,
  SolidType,
  SurfaceStyle,
  Theme,
  TransitionStyle,
} from "@once-ui-system/core";

/* Per-file paths, never a package index: the contexts index re-exports
   ToastProvider, whose Toaster import chains the entire component barrel
   (prism, recharts, emoji data — ~250KB transfer) back into every page.
   contexts/ and modules/ have no per-file subpath exports, so these reach
   into dist directly; the paths are stable within the pinned version. */
export { IconProvider } from "../../node_modules/@once-ui-system/core/dist/contexts/IconProvider.js";
export { LayoutProvider } from "../../node_modules/@once-ui-system/core/dist/contexts/LayoutProvider.js";
export {
  ThemeProvider,
  useTheme,
} from "../../node_modules/@once-ui-system/core/dist/contexts/ThemeProvider.js";
export { Meta } from "../../node_modules/@once-ui-system/core/dist/modules/seo/Meta.js";
export { Schema } from "../../node_modules/@once-ui-system/core/dist/modules/seo/Schema.js";
